import { Outlet, RouteObject } from 'react-router-dom';

import projectDetailsWizardRoutes from './project-details-wizard/project-details-wizard.routes';
import ChooseTemplateRootView from './choose-template-root.view';
import chooseTemplateLoader from './choose-template.loader';
import RouteGuard from '@ui/route-guard/route-guard';
import { getBaseAdminURL } from '@/utils/urls';

const ChooseTemplateRoutes: RouteObject[] = [
  {
    path: '*',
    id: 'choose-template-root',
    element: (
      <RouteGuard
        allowedRoles={[]}
        redirectTo={getBaseAdminURL()}
        unauthorizedMessage="Sorry, you don’t have permission to view this content. If you think this is a mistake, please contact your admin."
      >
        <ChooseTemplateRootView />
      </RouteGuard>
    ),
    shouldRevalidate: () => false,
    children: [
      {
        index: true,
        id: 'choose-template-catch-all',
        loader: chooseTemplateLoader,
        shouldRevalidate: () => false,
        async lazy() {
          const ChooseTemplate = await import('./choose-template/choose-template.view');
          return { Component: ChooseTemplate.default };
        },
      },
      {
        path: 'preview-template/:projectUuid',
        id: 'preview-template',
        shouldRevalidate: () => false,
        async lazy() {
          // const PreviewTemplate = await import('./preview-template/preview-template-original-designs.view');
          const PreviewTemplate = await import('./preview-template/preview-template.view');
          return { Component: PreviewTemplate.default };
        },
      },
      {
        path: 'project-details/wizard/:templateId',
        id: 'project-details/wizard/:templateId',
        element: <Outlet />,
        children: projectDetailsWizardRoutes,
      },
    ],
  },
];

export default ChooseTemplateRoutes;
